import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export interface EnviromentVariables {
  NEXT_PUBLIC_API_URL: string;
}

export const env: EnviromentVariables = publicRuntimeConfig;
